import { render } from "./ssedit.vue?vue&type=template&id=50d8bfba&scoped=true"
import script from "./ssedit.vue?vue&type=script&lang=js"
export * from "./ssedit.vue?vue&type=script&lang=js"

import "./ssedit.vue?vue&type=style&index=0&id=50d8bfba&lang=scss&scoped=true"
import "./ssedit.vue?vue&type=style&index=1&id=50d8bfba&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d8bfba"]])

export default __exports__